"use strict";
/*
 * Created on 09 07 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * @author Jaroslav Sevcik
 */


var SiteReleaseTerminationUploadConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SiteReleaseTerminationUploadConverter, _DataObjectConverter_);

  function SiteReleaseTerminationUploadConverter() {
    _classCallCheck(this, SiteReleaseTerminationUploadConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseTerminationUploadConverter).apply(this, arguments));
  }

  return SiteReleaseTerminationUploadConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SiteReleaseTerminationUploadConverter = SiteReleaseTerminationUploadConverter;